export const TEMPLATES = [
  {
    prompt_name: "Extract Clinical Keywords",
    prompt_code: "extract-clinical-keywords",
  },
  {
    prompt_name: "AI Voice Editor",
    prompt_code: "ai-voice-editor",
  },
  {
    prompt_name: "AI Voice Editor For Referral Letter",
    prompt_code: "ai-voice-editor-for-referral-letter",
  },
  {
    prompt_name: "AI Voice Editor For SOAP Note",
    prompt_code: "ai-voice-editor-for-soap-note",
  },
  {
    prompt_name: "SOAP Note with Previous SOAP Note as context updated",
    prompt_code: "soap-note-with-previous-soap-note-as-context",
  },
  {
    prompt_name: "Dynamic Language Converter for SOAP Note",
    prompt_code: "dynamic_language_converter_for_soap_note",
  },
  {
    prompt_name: "SOAP Note for First Visit",
    prompt_code: "soap-note-first-visit",
  },
  {
    prompt_name: "CDSS Prompt",
    prompt_code: "cdss-prompt",
  },
  {
    prompt_name: "Feedback on Doctor Performance",
    prompt_code: "feedback-on-doctor-performance",
  },
  {
    prompt_name: "Care Plan with Explanation",
    prompt_code: "care-plan-with-explanation",
  },
  {
    prompt_name: "Referral Letter with Previous SOAP Note as context",
    prompt_code: "referral-letter-with-previous-soap-note-as-context",
  },
  {
    prompt_name: "AI Voice Editor For Referral",
    prompt_code: "ai-voice-editor-for-referral",
  },
  {
    prompt_name: "SOAP Note for Follow-up Visit",
    prompt_code: "soap-note-follow-up-visit",
  },
  {
    prompt_name: "Clean Up",
    prompt_code: "clean-up",
  },
  {
    prompt_name: "SOAP Note Generic",
    prompt_code: "soap-note-generic",
  },
  {
    prompt_name: "Generate Title Based on Conversation",
    prompt_code: "generate-title-based-on-conversation",
  },
  {
    prompt_name: "Referral Letter",
    prompt_code: "referral-letter",
  },
];
